import { NgModule } from "@angular/core";
import { DECLARATIONS, EXPORTS, IMPORTS } from ".";

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...IMPORTS],
  exports: [...EXPORTS],
})
export class SharedModule {}
